/**
 * message.jsx
 * used for format that the rsvp messages will be displayed in
 */
import React, {useState, useEffect} from "react";
import Form from 'react-bootstrap/Form';
/**
 * function Message()
 * @param message = the message that is meant to be displayed
 * @param contactid = the sender of the message
 */
function Message({message ,contactid}) {
    const [sender, setSender] = useState("");
    const [hostMsg, setHostMsg] = useState("");
    const [incomingMsg, setIncomingMsg] = useState("");

    /**
     * functoin checkSender()
     * checks who the message belongs to
     * baed off if the viewing contact sent it or not
     * will affect the styling of the displaying messages
     */
    function checkSender() {
        //contact viewing is the one who sent the message
        if(contactid === message.contactid) {
            setSender(true);
        //the host of the event send the message (event update)
        } else if(message.isHost) {
            setHostMsg(true);
        //rsvp message coming from other contact
        } else {
            setIncomingMsg(true);
        }
    }

    useEffect(() => {
        checkSender();
        //eslint-disable-next-line react-hooks/exhaustive-deps
    },[contactid]);

    return (
        <div>
            {
                sender && (
                    <div style={{textAlign: "right"}}>
                        <Form.Text className="text-muted">{sender} {message.sender} {message.date} {message.time}</Form.Text>
                        <div style={{backgroundColor: "rgb(226,228,226)", width: "40%", borderRadius: "10%", marginLeft: "60%"}}>
                            <p style={{textAlign: "center"}}>{message.message}</p>
                        </div>
                    </div>
                )
            }
            {
                incomingMsg && (
                    <div style={{textAlign: "left"}}>
                        <Form.Text className="text-muted">{sender} {message.sender} {message.date} {message.time}</Form.Text>
                        <div style={{backgroundColor: "rgb(226,228,226)", width: "40%", textAlign: "center", borderRadius: "10%"}}>
                            <p style={{whiteSpace: 'pre-line'}}>{message.message}</p>
                        </div>
                    </div>
                )
            }
            {
                hostMsg && (
                    <div style={{textAlign: "center"}}>
                        <Form.Text style={{marginRight: "1%"}} className="text-muted">Host: {message.sender} {message.data} {message.time}</Form.Text>
                        <div style={{backgroundColor: "#890E32", width: "50%", borderRadius: "10%", margin: "auto", color: "white", marginRight: "1%"}}>
                        <p style={{whiteSpace: "pre-line"}}>{message.message}</p>
                        </div>
                    </div>
                )
            }
        </div>
    )
}

export default Message;